import React, { Component } from "react";
import {
  FieldGroup,
  FieldControl,
  FormBuilder,
  Validators
} from "react-reactive-form";
import { Auth, API } from "aws-amplify";
import PropTypes from "proptypes";
import {
  readableResponseMessage,
  phoneNumberValidator,
  scroller
} from "ux-helpers";

export default class EmergencyContact extends Component {
  state = {
    message: ""
  };

  compareEmails = control => {
    if (
      control.value &&
      control.value.toLowerCase() === this.props.user.email.toLowerCase()
    ) {
      return { email: true };
    } else {
      return null;
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.emergencyContactForm.status === "VALID") {
      this.setState({ loadingBtn: true });
      this.emergencyContactForm.handleSubmit();
      Auth.currentSession().then(user => {
        const options = {
          headers: {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            "Content-Type": "application/json"
          },
          body: this.emergencyContactForm.value
        };
        options.body.userId = this.props.user.id;
        options.body.userName = user.idToken.payload.nickname;

        API.post("give-api", "/user/", options)
          .then(response => {
            this.props.setAppState({
              ...this.props.user,
              ...this.emergencyContactForm.value
            });
            this.setState({
              loadingBtn: false,
              message: response.Message
            });
            this.emergencyContactForm.handleSubmit();
            this.props.deactiveActiveAccordion("emergencyContact-widget");
            scroller("emergencyContact");
            setTimeout(() => {
              this.setState({ message: "" });
            }, 3000);
          })
          .catch(error => {
            this.setState({
              loadingBtn: false,
              message: readableResponseMessage(error)
            });
            this.emergencyContactForm.handleSubmit();
          });
      });
    } else {
      this.emergencyContactForm.handleSubmit();
    }
  };

  emergencyContactForm = FormBuilder.group({
    emergencyContact: [this.props.user.emergencyContact, Validators.required],
    eCEmail: [
      this.props.user.eCEmail,
      [Validators.required, Validators.email, this.compareEmails]
    ],
    eCPhone: [
      this.props.user.eCPhone,
      [Validators.required, phoneNumberValidator]
    ],
    eCRelationship: [this.props.user.eCRelationship, Validators.required]
  });

  render() {
    return (
      <div>
        {this.state.message ? (
          <p
            className={`center ${
              this.state.message === "Your profile was successfully updated."
                ? "success"
                : "error"
            }`}
          >
            {this.state.message}
          </p>
        ) : (
          ""
        )}
        <p>Enter your Emergency Contact Information. <i>Do not enter your own contact information!</i></p>
        <FieldGroup
          control={this.emergencyContactForm}
          render={({ value, submitted }) => (
            <form
              name="Emergency Contact"
              id="emergency-contact-form"
              onSubmit={e => this.handleSubmit(e, value)}
              autoComplete="off"
            >
              <div>
                <FieldControl
                  name="emergencyContact"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input
                        id="emergencyContact"
                        className="form-control"
                        type="text"
                        {...handler()}
                      />
                      <label
                        htmlFor="emergencyContact"
                        className={`label ${
                          pristine &&
                          !this.emergencyContactForm.controls.emergencyContact
                            .value
                            ? ""
                            : "notEmpty"
                        }`}
                      >
                        Emergency Contact Name
                        <span className="error">
                          {(touched || submitted) &&
                            hasError("required") &&
                            " - Required"}
                        </span>
                      </label>
                    </div>
                  )}
                />

                <FieldControl
                  name="eCRelationship"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input
                        id="eCRelationship"
                        className="form-control"
                        type="text"
                        {...handler()}
                      />
                      <label
                        htmlFor="eCRelationship"
                        className={`label ${
                          pristine &&
                          !this.emergencyContactForm.controls.eCRelationship
                            .value
                            ? ""
                            : "notEmpty"
                        }`}
                      >
                        Emergency Contact Relationship
                        <span className="error">
                          {(touched || submitted) &&
                            hasError("required") &&
                            " - Required"}
                        </span>
                      </label>
                    </div>
                  )}
                />

                <FieldControl
                  name="eCEmail"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input
                        id="eCEmail"
                        className="form-control"
                        type="text"
                        {...handler()}
                      />
                      <label
                        htmlFor="eCEmail"
                        className={`label ${
                          pristine &&
                          !this.emergencyContactForm.controls.eCEmail.value
                            ? ""
                            : "notEmpty"
                        }`}
                      >
                        Emergency Contact Email
                        <span className="error">
                          {(touched || submitted) &&
                            hasError("required") &&
                            " - Required"}
                          {touched &&
                            hasError("email") &&
                            " - not a valid email"}
                        </span>
                      </label>
                    </div>
                  )}
                />

                <FieldControl
                  name="eCPhone"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input
                        id="eCPhone"
                        className="form-control"
                        type="text"
                        {...handler()}
                      />
                      <label
                        htmlFor="eCPhone"
                        className={`label ${
                          pristine &&
                          !this.emergencyContactForm.controls.eCPhone.value
                            ? ""
                            : "notEmpty"
                        }`}
                      >
                        Emergency Contact Phone Number
                        <span className="error">
                          {((touched || submitted) &&
                            hasError("required") &&
                            " - Required") ||
                            (touched &&
                              hasError("phoneNumber") && (
                                <span className="bubble-error-message">
                                  Format: XXX-XXX-XXXX, International
                                  X-XXX-XXX-XXXX
                                </span>
                              ))}
                        </span>
                      </label>
                    </div>
                  )}
                />

                <button
                  className={`${this.state.loadingBtn ? "btn-text-hide" : ""}`}
                  type="submit"
                  disabled={this.state.loadingBtn}
                >
                  Submit
                  <span
                    className={`${this.state.loadingBtn ? "loader" : ""}`}
                  />
                </button>
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}

EmergencyContact.propTypes = {
  setAppState: PropTypes.func
};

EmergencyContact.defaultProps = {
  setAppState: () => {}
};
